<template>
  <div id="app">
    <Header />
    <RouterView />
  </div>
</template>

<script>

import Header from './components/Header.vue'

export default {
  name: 'App',
  components: {
    Header
  }
}
</script>

<style scoped>
  @font-face {
    font-family: "InriaSerif";
    src: local("InriaSerif"), url('./fonts/inria-serif/InriaSerif-Regular.ttf') format('truetype');
  }

  @font-face {
    font-family: "InriaSerif-Bold";
    src: local("InriaSerif-Bold"), url('./fonts/inria-serif/InriaSerif-Bold.ttf') format('truetype');
  }


</style>
